// _           __   ___   _____    __   _   _   __   _   _____
// | |        / /  /   | |  _  \  |  \ | | | | |  \ | | /  ___|
// | |  __   / /  / /| | | |_| |  |   \| | | | |   \| | | |
// | | /  | / /  / / | | |  _  /  | |\   | | | | |\   | | |  _
// | |/   |/ /  / /  | | | | \ \  | | \  | | | | | \  | | |_| |
// |___/|___/  /_/   |_| |_|  \_\ |_|  \_| |_| |_|  \_| \_____/

// THIS FILE IS AUTO GENERATED!!!!!!
// DO NO EDIT IT HERE.

// THE TEMPLATE IS AT: tasks/pkg/icon-template/src/index.tsx

import baseIcon, { defaultIconGroupProps } from '@bubble-ui/temp-icon-base';
var IconRocketPath = 'M4.789 10.268c-.224.18-.372.425-.382.63l-.125 1.675 2.19-.71-.006-2.957-1.677 1.361Zm5.66-7.892-.919.876c-.686.652-1.077 1.654-1.075 2.75L8.461 6v6h4V6c-.002-1.094-.404-2.104-1.091-2.752l-.921-.872Zm6.067 8.548c-.011-.23-.16-.476-.38-.652l-1.683-1.367.006 2.961 2.18.707-.123-1.65ZM7.473 14h-.002a.985.985 0 0 1-.536-.179L2 15.426l.346-4.646c.036-.75.445-1.507 1.121-2.049l2.994-2.43v-.296c-.003-1.642.615-3.174 1.696-4.203L9.76.276a.994.994 0 0 1 1.372-.002l1.607 1.52c1.083 1.023 1.706 2.552 1.709 4.193v.305l3.01 2.442c.672.54 1.082 1.296 1.119 2.07l.344 4.622-4.938-1.606a.96.96 0 0 1-.517.167L7.473 14Zm3.988 1v.25A2.752 2.752 0 0 0 14.21 18v2a4.73 4.73 0 0 1-3.817-1.95C9.479 19.228 8.064 20 6.46 20v-2c1.654 0 3-1.346 3-3h2Z';
var IconRocket = baseIcon('IconRocket', {
  groupProps: defaultIconGroupProps,
  getPath: () => IconRocketPath
});
export default IconRocket;
//# sourceMappingURL=index.js.map